import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import moment from 'moment'
import { connect } from 'react-redux';
import { Button, Form, Modal, Input, Row ,Col} from 'antd';

class RegisterInfo extends Component {
  constructor(props){
    super(props)
    this.state={}
    this.handleOKClick = this.handleOKClick.bind(this);
  }
  getRegistInfo(){
    let proxy = cb.rest.DynamicProxy.create({
        getInfo: {
            url: '/bill/getRegistInfo',
            method: 'POST',
            options: { token: true }
        }
    });
    let data = {
      "fullname": "aa.registInfo.RegistInfo",
      "data": "*"
    }
    proxy.getInfo(data, (err, result ) =>{
        if(!err){
          this.setState({data:result})
        }else{
          cb.utils.alert('获取列表失败','error')
        }
    })
  }
  componentDidMount() {
    this.getRegistInfo()
  }
  handleOKClick(systemCode,index){
    let _this =  this;
    let proxy = cb.rest.DynamicProxy.create({
        getInfo: {
            url: '/api/upc/openUPC',
            method: 'POST',
            options: { token: true }
        }
    });
    let data = {
      "systemCode": systemCode
    }
    proxy.getInfo(data, (err, result ) =>{
        if(!err){
          cb.utils.alert('开通成功','success')
          let {data} = _this.state;
          data.splice(index,1,result)
          _this.setState({data:data})
        }else{
          cb.utils.alert('开通失败','error')
        }
    })
  }
  info(data,index){
    return <Col span={12} className='register-info clearfix'>
      <div className={'register-info-logo '+data.systemCode}>
      </div>
      <div className='register-info-detial'>
        <h2 className="register-info-title">
          {data.systemName}
          {
            data.isOpen ? <span className="official">正式版</span> : <span className="try">试用版</span>
          }
        </h2>
        {
          !data.isRegisted ?
          <Button onClick={()=>this.handleOKClick(data.systemCode,index)}>立即开通</Button> :
          <Row className='register-info-time'>
            <Col span={12} className='register-info-time-key'>注册时间</Col>
            <Col span={12} className='register-info-time-value'>{data.registDate && moment(data.registDate).format('YYYY-MM-DD')}</Col>
          </Row>
        }
        {/*
          <Row className='register-info-time'>
            <Col span={12} className='register-info-time-key'>注册时间</Col>
            <Col span={12} className='register-info-time-value'>{data.registDate && moment(data.registDate).format('YYYY-MM-DD')}</Col>
          </Row>
          <Row className='register-info-time'>
            <Col span={12} className='register-info-time-key'>开通时间</Col>
            <Col span={12} className='register-info-time-value'>{data.openDate && moment(data.startTime).format('YYYY-MM-DD')}</Col>
          </Row>
          <Row className='register-info-time'>
            <Col span={12} className='register-info-time-key'>服务时间</Col>
            <Col span={12} className='register-info-time-value'>{data.serviceStartDate && moment(data.serviceStartDate).format('YYYY-MM-DD') || '2018-12-31'} -{data.serviceEndDate && moment(data.serviceEndDate).format('YYYY-MM-DD')}</Col>
          </Row>
        */}
      </div>
    </Col>
  }
  list(listdata){
    return (
      <Row className="p-l-20">
        {
          listdata.map((value,index)=>{
            return this.info(value,index)
        })
      }
      </Row>
    )
  }
  render() {
    let data = this.state.data;
    return data?this.list(data):null
  }
}

function mapStateToProps(state) {
  return {}
}

function mapDispatchToProps(dispatch) {
  return {
    systemSettingactions: bindActionCreators('', dispatch)
  }
}

export default RegisterInfo //connect(mapStateToProps, mapDispatchToProps)(ApiInfo);



// WEBPACK FOOTER //
// ./src/common/components/system-setting/RegisterInfo.jsx